@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.driverdevices
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.core.DateTimeDto
import com.narbase.letsgo.web.models.InternetProviderName

class DriverDeviceDto (
    val id: KmmLong?,
    val driverId: KmmLong,
    val deviceUuid: String,
    val model: String,
    val manufacturer: String,
    val currentOs: String,
    val appVersion: String,
    @Suppress("NON_EXPORTABLE_TYPE") val internetProvider: DtoName<InternetProviderName>,
    val lastUpdated: DateTimeDto
)